import { __ } from '@wordpress/i18n';
import { useCombobox } from 'downshift';
import { useState } from 'preact/hooks';

import { Country } from '../../../../types';

function getItemsFilter( inputValue: string ) {
	const lowerCasedInputValue = inputValue.toLowerCase();

	return function itemsFilter( item: Country ) {
		return (
			! inputValue ||
			item.name.toLowerCase().includes( lowerCasedInputValue )
		);
	};
}

export default function CountryCombobox( { countries, activeCountry, handleCountryChange } : {
	countries: Country[];
	activeCountry: Country;
	handleCountryChange: Function;
} ) {
	const [ items, setItems ] = useState( countries );

	const {
		getLabelProps,
		getMenuProps,
		getInputProps,
		getItemProps,
		highlightedIndex,
		isOpen,
		selectedItem,
	} = useCombobox( {
		onInputValueChange( { inputValue } ) {
			setItems( countries.filter( getItemsFilter( inputValue ) ) );
		},
		items,
		itemToString( item: Country ) {
			return item ? item.name : '';
		},
		selectedItem: activeCountry,
		onSelectedItemChange: ( { selectedItem: newSelectedItem } ) => {
			handleCountryChange( newSelectedItem );
		},
	} );

	const hasItems = items?.length > 0;

	return (
		<div className="tcc-map__filter tcc-map__filter--country">
			<div className="tcc-map__filter-input-wrapper">
				<label
					className="tcc-map__filter-label screen-reader-text"
					{ ...getLabelProps() }
					htmlFor="tcc-map__filter-input--country"
				>
					{ __( 'Countries', 'tcc-map' ) }
				</label>
				<input
					type="text"
					placeholder={ __( 'Search by country', 'tcc-map' ) }
					className="tcc-map__filter-input"
					{ ...getInputProps() }
					id="tcc-map__filter-input--country"
				/>
			</div>
			{ hasItems && (
				<ul
					className={ `tcc-map__filter-options ${ ( isOpen && items.length ) && 'visible' }` }
					{ ...getMenuProps() }
				>
					{ isOpen && items.map( ( item, index ) => {
						const { name, post_id } = item;
						if ( ! name ) {
							return null;
						}
						return (
							<li
								key={ post_id }
								className={ `tcc-map__filter-option ${ highlightedIndex === index ? 'highlighted' : '' } ${ selectedItem === item ? 'selected' : '' }` }
								{ ...getItemProps( { item, index } ) }
							>
								<span>{ name }</span>
							</li>
						);
					} ) }
				</ul>
			) }
		</div>
	);
}
